import React from 'react';
import ReactDOM from 'react-dom';

import {Domain, Stage} from "@zooplus/commons-lang";
import {PDPProduct} from "./model/BonusPointsProduct";
import {ViewType} from "./model/ViewType";
import PDP from "./components/PDP";

const component = document.getElementById('bonus-points-pdp-wrapper');

if (component) {
  const siteDomain = component.getAttribute('data-site-domain') as Domain;
  const product = JSON.parse(component.getAttribute('data-product')!) as PDPProduct;
  const mediaServerURL = component.getAttribute('data-media-server-url')!;
  const reviewNumberTranslation = component.getAttribute('data-review-number-translation')!;
  const redeemableBalance = Number(component.getAttribute('data-redeemable-balance'));
  const selection = component.getAttribute('data-selection');
  const environment = component.getAttribute('data-environment') as Stage;
  const view = component.getAttribute('data-view') as ViewType;

  if (siteDomain
    && product
    && mediaServerURL
    && reviewNumberTranslation
    && selection
    && environment
  ) {
    ReactDOM.render(
      <PDP
        siteDomain={siteDomain}
        product={product}
        mediaServerUrl={mediaServerURL}
        reviewNumberTranslation={reviewNumberTranslation}
        selection={JSON.parse(selection)}
        environment={environment}
        redeemableBalance={redeemableBalance}
        view={view}
      />,
      component,
    );
  }
}
